import React, { useEffect, useState } from "react";
import { Navbar, Container, Image, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { toggleSidebar } from "../../../store/slices/CommonSlice";
import { useDispatch, useSelector } from "react-redux";
import configuration from "react-global-configuration";
import { useTranslation } from "react-multi-lang";

const CollapseSidebar = (props) => {
  const t = useTranslation("collaspe_sidebar")
  const location = useLocation();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.admin.profile);

  return (
    <>
      <div className={`admin-ui-sidebar admin-ui-collapse-sidebar`}>
        <div className="admin-ui-sidebar-collapse">
          <div className="admin-overlay-hidden"></div>
          <div className="admin-ui-logo-sec">
            {/* <Link className="" to="/">
              <Image
                className="admin-ui-logo"
                src={
                  window.location.origin + "/images/haive-text-logo.svg"
                }
              />
            </Link> */}
            <div className="admin-user-details">
              <Image
                className="logo"
                src={configuration.get("configData.site_logo")}
              />
              <Button
                className="offcanvas-close"
                onClick={() => dispatch(toggleSidebar())}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="#18AF8B"
                  data-name="Layer 1"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.341 9.48l-3.501-6A5.016 5.016 0 0015.522 1H8.451a5.02 5.02 0 00-4.319 2.48l-3.501 6a5.01 5.01 0 000 5.039l3.501 6a5.016 5.016 0 004.318 2.48h7.071a5.02 5.02 0 004.319-2.48l3.5-6a5.01 5.01 0 000-5.039zm-1.729 4.031l-3.499 6a3.011 3.011 0 01-2.592 1.488H8.45a3.01 3.01 0 01-2.591-1.488l-3.5-6a3.004 3.004 0 010-3.023l3.499-6A3.011 3.011 0 018.45 3h7.071a3.01 3.01 0 012.591 1.488l3.5 6a3.004 3.004 0 010 3.023zm-5.905-3.805l-2.293 2.293 2.293 2.293a.999.999 0 11-1.414 1.414L12 13.413l-2.293 2.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414l2.293-2.293-2.293-2.293a.999.999 0 111.414-1.414L12 10.585l2.293-2.293a.999.999 0 111.414 1.414z"></path>
                </svg>
              </Button>
            </div>
          </div>
          <div className="admin-ui-collapse-body">
            <ul className="admin-ui-sidebar-list list-unstyled">
              <li>
                <Link
                  to="/"
                  onClick={() => dispatch(toggleSidebar())}
                  className={`${location.pathname === "/" && "active"}`}
                >
                  <div className="collapse-icons">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="none"
                    viewBox="0 0 22 22"
                  >
                    <path
                      fill="#000"
                      d="M18.417 21.667h-3.89a2.622 2.622 0 0 1-1.84-4.464l4.517-4.517a2.622 2.622 0 0 1 4.463 1.842v3.889a3.25 3.25 0 0 1-3.25 3.25m.628-7.584a.42.42 0 0 0-.303.13l-4.528 4.529a.42.42 0 0 0-.098.487.44.44 0 0 0 .412.271h3.889a1.083 1.083 0 0 0 1.083-1.083v-3.89a.44.44 0 0 0-.27-.411.8.8 0 0 0-.185-.033M4.875 9.75A4.875 4.875 0 1 1 9.75 4.875 4.886 4.886 0 0 1 4.875 9.75m0-7.583a2.708 2.708 0 1 0 0 5.416 2.708 2.708 0 0 0 0-5.416"
                    ></path>
                    <path
                      fill="#000"
                      d="M18.417 9.75h-3.25a3.25 3.25 0 0 1-3.25-3.25V3.25A3.25 3.25 0 0 1 15.167 0h3.25a3.25 3.25 0 0 1 3.25 3.25V6.5a3.25 3.25 0 0 1-3.25 3.25m-3.25-7.583a1.083 1.083 0 0 0-1.083 1.083V6.5a1.083 1.083 0 0 0 1.083 1.083h3.25A1.083 1.083 0 0 0 19.5 6.5V3.25a1.083 1.083 0 0 0-1.083-1.083zM6.5 21.667H3.25A3.25 3.25 0 0 1 0 18.417v-3.25a3.25 3.25 0 0 1 3.25-3.25H6.5a3.25 3.25 0 0 1 3.25 3.25v3.25a3.25 3.25 0 0 1-3.25 3.25m-3.25-7.584a1.083 1.083 0 0 0-1.083 1.084v3.25A1.083 1.083 0 0 0 3.25 19.5H6.5a1.083 1.083 0 0 0 1.083-1.083v-3.25A1.083 1.083 0 0 0 6.5 14.083z"
                      opacity="0.5"
                    ></path>
                  </svg>
                  </div>
                  <span>{t("dashboard")}</span>
                </Link>
              </li>
              {profile.data.kyc_status == 3 && (
                <React.Fragment>
                  {/* {profile.data.payin_access == 1 && ( */}
                    <>
                      {/* <li>
                        <Link
                          to="/api-reference"
                          className={`${
                            location.pathname.includes("/api-reference") &&
                            "active"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <g clipPath="url(#clip0_22_242)">
                              <path d="M0 0H20V20H0z"></path>
                              <path
                                fill="#111"
                                stroke="#111"
                                strokeWidth="0.5"
                                d="M8.593 13.538l-2.93.099c-1.766.034-3.23-1.49-3.27-3.401C2.353 8.36 3.7 6.8 5.428 6.716l2.933-.1c.35-.012.625-.33.612-.71-.013-.38-.308-.679-.66-.667l-2.931.1C2.916 5.424.99 7.658 1.08 10.33c.091 2.672 2.164 4.77 4.63 4.686l2.931-.099c.35-.018.62-.341.6-.721-.018-.37-.304-.66-.646-.655l-.002-.002h0zM18.947 9.704c-.04-1.284-.551-2.5-1.422-3.377-.866-.882-2.02-1.354-3.204-1.31l-2.933.096c-.351.012-.626.33-.613.71.013.38.307.679.659.667l2.932-.097a3.055 3.055 0 012.293.937c1.292 1.31 1.365 3.5.163 4.894a3.077 3.077 0 01-2.224 1.089l-2.93.099c-.352.011-.626.33-.613.71.012.38.307.679.659.667l2.93-.098c2.464-.086 4.39-2.316 4.303-4.987z"
                              ></path>
                              <path
                                fill="#111"
                                stroke="#111"
                                strokeWidth="0.5"
                                d="M12.687 9.235l-5.392.182c-.35.005-.63.317-.623.698.006.38.296.684.648.679a.54.54 0 00.022-.001l5.39-.182c.351-.018.62-.341.601-.72-.018-.371-.304-.661-.646-.656z"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_22_242">
                                <path d="M0 0H20V20H0z"></path>
                              </clipPath>
                            </defs>
                          </svg>
                          <span>{t("payin_api")}</span>
                        </Link>
                      </li> */}
                      {/* <li>
                  <Link to="/api-payment" className={`${location.pathname.includes("/api-payment") && "active"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <g clipPath="url(#clip0_22_242)">
                        <path d="M0 0H20V20H0z"></path>
                        <path
                          fill="#111"
                          stroke="#111"
                          strokeWidth="0.5"
                          d="M8.593 13.538l-2.93.099c-1.766.034-3.23-1.49-3.27-3.401C2.353 8.36 3.7 6.8 5.428 6.716l2.933-.1c.35-.012.625-.33.612-.71-.013-.38-.308-.679-.66-.667l-2.931.1C2.916 5.424.99 7.658 1.08 10.33c.091 2.672 2.164 4.77 4.63 4.686l2.931-.099c.35-.018.62-.341.6-.721-.018-.37-.304-.66-.646-.655l-.002-.002h0zM18.947 9.704c-.04-1.284-.551-2.5-1.422-3.377-.866-.882-2.02-1.354-3.204-1.31l-2.933.096c-.351.012-.626.33-.613.71.013.38.307.679.659.667l2.932-.097a3.055 3.055 0 012.293.937c1.292 1.31 1.365 3.5.163 4.894a3.077 3.077 0 01-2.224 1.089l-2.93.099c-.352.011-.626.33-.613.71.012.38.307.679.659.667l2.93-.098c2.464-.086 4.39-2.316 4.303-4.987z"
                        ></path>
                        <path
                          fill="#111"
                          stroke="#111"
                          strokeWidth="0.5"
                          d="M12.687 9.235l-5.392.182c-.35.005-.63.317-.623.698.006.38.296.684.648.679a.54.54 0 00.022-.001l5.39-.182c.351-.018.62-.341.601-.72-.018-.371-.304-.661-.646-.656z"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_22_242">
                          <path d="M0 0H20V20H0z"></path>
                        </clipPath>
                      </defs>
                    </svg>
                    <span>API Payment</span>
                  </Link>
                </li> */}
                      {/* <li>
                        <Link
                          to="/transactions"
                          className={`${
                            location.pathname == "/transactions" && "active"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <path
                              stroke="#111"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4.615 10L3.077 8.328 1.539 10M15.385 10l1.538 1.672L18.462 10"
                            ></path>
                            <path
                              stroke="#111"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M16.923 11.672V10a7.975 7.975 0 00-1.28-4.334c-.827-1.267-1.996-2.224-3.345-2.74a6.4 6.4 0 00-4.187-.14c-1.376.423-2.597 1.3-3.496 2.508M3.077 8.328V10a7.975 7.975 0 001.28 4.334c.828 1.267 1.996 2.224 3.345 2.74a6.4 6.4 0 004.187.14c1.376-.423 2.597-1.3 3.496-2.508"
                            ></path>
                          </svg>
                          <span>{t("transactions")}</span>
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          to="/invoice-payment"
                          className={`${
                            location.pathname.includes("/invoice-payment") &&
                            "active"
                          }`}
                        >
                           <div className="collapse-icons">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 20 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.5 9.16665C2.5 5.70968 2.5 3.9812 3.47631 2.90725C4.45262 1.83331 6.02397 1.83331 9.16667 1.83331H10.8333C13.976 1.83331 15.5474 1.83331 16.5237 2.90725C17.5 3.9812 17.5 5.70968 17.5 9.16665V12.8333C17.5 16.2902 17.5 18.0188 16.5237 19.0927C15.5474 20.1666 13.976 20.1666 10.8333 20.1666H9.16667C6.02397 20.1666 4.45262 20.1666 3.47631 19.0927C2.5 18.0188 2.5 16.2902 2.5 12.8333V9.16665Z"
                              stroke="#fff"
                              stroke-width="2"
                            />
                            <path
                              d="M9.3252 12.3223L10.6748 11.3444"
                              stroke="#fff"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M10.1173 14.8357L9.7317 15.1151C8.4539 16.0409 6.76131 15.8851 5.95121 14.767C5.1411 13.6489 5.52024 11.992 6.79804 11.0662L7.18365 10.7868"
                              stroke="#fff"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M9.88281 8.83099L10.2684 8.5516C11.5462 7.62576 13.2388 7.7816 14.0489 8.89967C14.859 10.0177 14.4799 11.6747 13.2021 12.6005L12.8165 12.8799"
                              stroke="#fff"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                          </svg>
                          </div>
                          <span>{t("invoice_payment")}</span>
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          to="/settlement"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname.includes("settlement") && "active"
                          }`}
                        >
                           <div className="collapse-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="26"
                            fill="none"
                            viewBox="0 0 26 26"
                          >
                            <path
                              fill="#000"
                              d="M21.368 19.789a10.82 10.82 0 0 1-11.823 3.503A10.82 10.82 0 0 1 4.29 19.54a10.8 10.8 0 0 1-2.179-6.076l-.325.325a1.083 1.083 0 0 1-1.785-.78 1.08 1.08 0 0 1 .26-.745l2.164-2.162a1.083 1.083 0 0 1 1.526 0l2.165 2.162a1.08 1.08 0 0 1 0 1.525 1.083 1.083 0 0 1-1.526 0l-.314-.314a8.64 8.64 0 0 0 1.784 4.828 8.66 8.66 0 0 0 9.364 3.008 8.66 8.66 0 0 0 4.266-2.883 1.086 1.086 0 0 1 1.885.987q-.061.207-.197.375zM25.589 13.788l-2.165 2.163a1.08 1.08 0 0 1-.768.313 1.08 1.08 0 0 1-.769-.313l-2.165-2.163a1.081 1.081 0 0 1 1.526-1.525l.303.303a8.64 8.64 0 0 0-1.783-4.827 8.66 8.66 0 0 0-9.364-3.009 8.66 8.66 0 0 0-4.266 2.884 1.083 1.083 0 0 1-1.516.173 1.08 1.08 0 0 1-.162-1.525 10.825 10.825 0 0 1 11.862-3.555c2.104.69 3.945 2.01 5.275 3.778A10.8 10.8 0 0 1 23.76 12.6l.335-.336a1.083 1.083 0 0 1 1.797 1.175 1.1 1.1 0 0 1-.27.35z"
                            ></path>
                            <path
                              fill="#000"
                              d="M11.863 16.29a1.08 1.08 0 0 1-.759-.313L8.938 13.81a1.084 1.084 0 1 1 1.527-1.538l1.398 1.408 3.575-3.575a1.083 1.083 0 1 1 1.527 1.538l-4.333 4.334a1.08 1.08 0 0 1-.77.314"
                              opacity="0.5"
                            ></path>
                          </svg>
                          </div>
                          <span>{t("settlement")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/invoice-transactions"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname.includes(
                              "invoice-transactions"
                            ) && "active"
                          }`}
                        >
                           <div className="collapse-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="18"
                            fill="none"
                            viewBox="0 0 22 18"
                          >
                            <path
                              fill="#000"
                              d="m17.018.32 4.332 4.332a1.083 1.083 0 0 1-1.538 1.527l-2.48-2.48v11.18a1.083 1.083 0 0 1-2.166 0V3.7l-2.48 2.48a1.085 1.085 0 0 1-1.538-1.527L15.48.32a1.08 1.08 0 0 1 1.538 0"
                            ></path>
                            <path
                              fill="#000"
                              d="M5.42 1.083a1.083 1.083 0 0 1 1.083 1.083v12.005l2.48-2.48a1.084 1.084 0 0 1 1.852.769 1.08 1.08 0 0 1-.315.769L6.189 17.56a1.08 1.08 0 0 1-.768.314c-.445 0-.445 0-5.101-4.646a1.088 1.088 0 0 1 1.537-1.538l2.48 2.49V2.167A1.083 1.083 0 0 1 5.42 1.083"
                              opacity="0.5"
                            ></path>
                          </svg>
                          </div>
                          <span>{t("payin_transactions")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/payin/reports"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname.includes("payin/reports") &&
                            "active"
                          }`}
                        >
                          <div className="collapse-icons">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              fill="none"
                              viewBox="0 0 22 22"
                            >
                              <path
                                fill="#000"
                                d="M3.667 2.75a.917.917 0 0 0-.917.917v14.666c0 .507.41.917.917.917h14.666c.507 0 .917-.41.917-.917V3.667a.917.917 0 0 0-.917-.917H3.667Zm0-1.833h14.666a2.75 2.75 0 0 1 2.75 2.75v14.666a2.75 2.75 0 0 1-2.75 2.75H3.667a2.75 2.75 0 0 1-2.75-2.75V3.667a2.75 2.75 0 0 1 2.75-2.75Z"
                              />
                              <path
                                fill="#000"
                                d="M6.417 15.583a.917.917 0 0 1-.917-.916V11a.917.917 0 1 1 1.833 0v3.667a.917.917 0 0 1-.916.916Zm4.583 0a.917.917 0 0 1-.917-.916V7.333a.917.917 0 1 1 1.834 0v7.334a.917.917 0 0 1-.917.916Zm4.583 0a.917.917 0 0 1-.916-.916V9.167a.917.917 0 1 1 1.833 0v5.5a.917.917 0 0 1-.917.916Z"
                                opacity="0.5"
                              />
                            </svg>
                          </div>
                          <span>{t("payin_reports")}</span>
                        </Link>
                      </li>
                    </>
                  {/* )} */}
                  {/* {profile.data.payout_access == 1 && ( */}
                    <>
                      {/* <li>
                        <Link
                          to="/payout-api"
                          className={`${
                            location.pathname == "/payout-api" && "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.259 22.322C11.2035 22.4855 9.1344 22.0362 7.31793 21.0321C5.50145 20.028 4.02064 18.515 3.06599 16.6876C2.11133 14.8602 1.72649 12.802 1.96095 10.7779C2.19541 8.75367 3.03846 6.85604 4.38165 5.32903C5.72485 3.80202 7.50676 2.71548 9.49819 2.20916C11.4896 1.70284 13.5995 1.7999 15.5564 2.48786C17.5134 3.17582 19.2278 4.42321 20.4794 6.06958C21.7309 7.71596 22.4622 9.68602 22.5792 11.7264"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M19.6954 20.6766L22.1504 18.179M22.1504 18.179L19.6823 15.6766M22.1504 18.179L14.1504 18.2005"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.5291 9H12.7039C12.4339 9 12.215 9.21889 12.215 9.48889V13.6608C12.215 13.9308 12.4339 14.1497 12.7039 14.1497C12.9739 14.1497 13.1928 13.9308 13.1928 13.6608V12.5852H14.5291C15.5176 12.5852 16.3217 11.7811 16.3217 10.7926C16.3217 9.80413 15.5176 9 14.5291 9ZM14.5291 11.6074H13.1928V9.97779H14.5291C14.9784 9.97779 15.3439 10.3433 15.3439 10.7926C15.3439 11.2419 14.9784 11.6074 14.5291 11.6074Z"
                              fill="black"
                            />
                            <path
                              d="M10.0327 9.31726C9.96111 9.12646 9.77872 9 9.57495 9H9.05347C8.84969 9 8.66724 9.1264 8.59573 9.31726L7.03127 13.4891C6.93643 13.7419 7.06458 14.0237 7.31737 14.1186C7.57016 14.2134 7.85196 14.0853 7.94681 13.8325L8.21889 13.1067H10.4095L10.6816 13.8324C10.7552 14.0287 10.9415 14.1498 11.1394 14.1498C11.1964 14.1498 11.2545 14.1398 11.311 14.1186C11.5638 14.0238 11.6919 13.7419 11.5971 13.4891L10.0327 9.31726ZM8.58556 12.1289L9.31421 10.1859L10.0429 12.1289H8.58556Z"
                              fill="black"
                            />
                            <path
                              d="M17.3972 9C17.1272 9 16.9083 9.21889 16.9083 9.48889V13.6608C16.9083 13.9308 17.1272 14.1497 17.3972 14.1497C17.6672 14.1497 17.8861 13.9308 17.8861 13.6608V9.48889C17.8861 9.21889 17.6672 9 17.3972 9Z"
                              fill="black"
                            />
                          </svg>
                          <span>{t("payout_api")}</span>
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          to="/payout-transactions"
                          className={`${
                            location.pathname == "/payout-transactions" &&
                            "active"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.2003 20.4217C10.3302 20.5704 8.44782 20.1617 6.79524 19.2482C5.14266 18.3347 3.79547 16.9582 2.92695 15.2956C2.05843 13.6331 1.70831 11.7607 1.92162 9.91914C2.13492 8.0776 2.9019 6.35118 4.12391 4.96195C5.34591 3.57272 6.96704 2.58422 8.77879 2.12358C10.5905 1.66295 12.51 1.75126 14.2904 2.37714C16.0708 3.00302 17.6306 4.13786 18.7691 5.63569C19.9077 7.13351 20.5731 8.92582 20.6796 10.7821"
                              stroke="black"
                              stroke-width="1.81954"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.7446 9.90897C12.5957 10.4942 12.0031 10.94 11.2823 10.94H10.3407C9.94146 10.94 9.59923 11.2298 9.59923 11.6092C9.59923 11.781 9.67412 11.9508 9.811 12.0729L12.553 14.6112C12.553 14.6113 12.5531 14.6113 12.5532 14.6114C12.6576 14.709 12.7984 14.7611 12.9426 14.7611C13.1764 14.7611 13.3603 14.6361 13.4426 14.4649C13.5257 14.2919 13.5011 14.0778 13.3322 13.9202L13.332 13.92L11.1825 11.9307H11.2823C12.5908 11.9307 13.6899 11.0554 13.8554 9.90897H14.2391C14.5291 9.90897 14.7849 9.69606 14.7849 9.41365C14.7849 9.13124 14.5291 8.91833 14.2391 8.91833H13.754C13.6742 8.69279 13.557 8.48172 13.4083 8.2916H14.2391C14.5291 8.2916 14.7849 8.07869 14.7849 7.79628C14.7849 7.51387 14.5291 7.30096 14.2391 7.30096H9.69021C9.40014 7.30096 9.14434 7.51387 9.14434 7.79628C9.14434 8.07869 9.40014 8.2916 9.69021 8.2916H11.2823C11.8255 8.2916 12.2945 8.54505 12.557 8.91833H9.69021C9.40014 8.91833 9.14434 9.13124 9.14434 9.41365C9.14434 9.69606 9.40014 9.90897 9.69021 9.90897H12.7446Z"
                              fill="black"
                              stroke="black"
                              stroke-width="0.181954"
                            />
                            <path
                              d="M18.0559 18.9248L20.2894 16.6525M20.2894 16.6525L18.044 14.3759M20.2894 16.6525L13.0112 16.6721"
                              stroke="black"
                              stroke-width="1.81954"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>INR Payout Transactions</span>
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          to="/deposit-payout"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname == "/deposit-payout" && "active"
                          }`}
                        >
                           <div className="collapse-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                            fill="none"
                            viewBox="0 0 20 18"
                          >
                            <path
                              fill="#000"
                              d="M2.172 17.338h10.289a7.04 7.04 0 0 0 7.039-7.042 7.043 7.043 0 0 0-7.04-7.041H1.437a1.083 1.083 0 0 0 0 2.166H12.46a4.87 4.87 0 0 1 4.873 4.875 4.875 4.875 0 0 1-4.873 4.875H2.172a1.083 1.083 0 1 0 0 2.167"
                              opacity="0.5"
                            ></path>
                            <path
                              fill="#000"
                              d="M4.338 8.671a1.083 1.083 0 0 0 .77-1.852L2.616 4.338l2.49-2.481A1.088 1.088 0 0 0 3.57.319L.32 3.569a1.083 1.083 0 0 0 0 1.538l3.25 3.25a1.08 1.08 0 0 0 .768.314"
                            ></path>
                          </svg>
                          </div>
                          <span>{t("deposit_payout")} </span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/merchant-payout"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname == "/merchant-payout" && "active"
                          }`}
                        >
                           <div className="collapse-icons">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="21"
                              height="21"
                              fill="none"
                              viewBox="0 0 21 21"
                            >
                              <path
                                fill="#000"
                                d="M14.408 20.583H6.175A6.175 6.175 0 0 1 0 14.408V6.175A6.175 6.175 0 0 1 6.175 0h3.087a1.03 1.03 0 1 1 0 2.058H6.176a4.117 4.117 0 0 0-4.117 4.117v8.233a4.117 4.117 0 0 0 4.117 4.117h8.233a4.117 4.117 0 0 0 4.117-4.117v-3.087a1.03 1.03 0 1 1 2.058 0v3.087a6.175 6.175 0 0 1-6.175 6.175"
                              ></path>
                              <path
                                fill="#000"
                                d="M20.583 1.03v5.145a1.03 1.03 0 1 1-2.058 0V3.52l-7.503 7.502a1.03 1.03 0 0 1-1.451 0 1.03 1.03 0 0 1 0-1.45l7.513-7.514h-2.676a1.03 1.03 0 0 1 0-2.058h5.146a1.03 1.03 0 0 1 1.029 1.03"
                                opacity="0.5"
                              ></path>
                            </svg>
                          </div>
                          <span>{t("payout_transactions")}</span>
                        </Link>
                      </li>
                    </>
                  {/* )} */}
                  {/* {profile.data.payin_access == 1 && ( */}
                    <>
                      <li>
                        <Link
                          to="/bank-accounts"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname.includes("bank-account") &&
                            "active"
                          }`}
                        >
                           <div className="collapse-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            fill="none"
                            viewBox="0 0 22 22"
                          >
                            <path
                              stroke="#000"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3.188 10.75v6.5m7.573-6.5v6.5m7.594-6.5v6.5"
                              opacity="0.5"
                            ></path>
                            <path
                              stroke="#000"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M1.022 20.5H19.44M1.759 4.966l6.966-3.478a4.54 4.54 0 0 1 4.095 0l6.955 3.467a1.343 1.343 0 0 1-.596 2.546H2.355a1.332 1.332 0 0 1-.596-2.535"
                            ></path>
                          </svg>
                          </div>
                          <span>{t("bank_accounts")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/agents"
                          onClick={() => dispatch(toggleSidebar())}
                          className={`${
                            location.pathname.includes("agents") && "active"
                          }`}
                        >
                          <div className="collapse-icons">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke="#000"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20c0-3.3137 2.6863-6 6-6h4c3.3137 0 6 2.6863 6 6"
                              ></path>
                            </svg>
                          </div>
                          <span>{t("agents")}</span>
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to="/customise-payment"
                          className={`${
                            location.pathname.includes("customise-payment") &&
                            "active"
                          }`}
                        >
                           <div className="collapse-icons">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.7193 10.6329C18.1883 10.0209 17.2631 10.0209 16.7326 10.6329L13.0435 14.8842V17.1739H15.0301L18.7188 12.9226C18.9843 12.6166 19.1304 12.2102 19.1304 11.7774C19.1304 11.3446 18.9843 10.9383 18.7193 10.6329ZM18.0568 12.159L14.6425 16.0946H13.9799V15.331L17.3947 11.3959C17.5712 11.1919 17.8798 11.1919 18.0568 11.3959C18.1453 11.4974 18.194 11.6328 18.194 11.7774C18.194 11.9221 18.1453 12.057 18.0568 12.159Z"
                              fill="#fff"
                              stroke="#fff"
                              stroke-width="0.5"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M4.14468 1H15.0615C16.8664 1 18.3365 2.59285 18.3365 4.54842V8.53447C18.099 8.46417 17.8562 8.40927 17.6088 8.37075V7.3083H1.59742V14.7994C1.59742 16.3213 2.74004 17.5593 4.14468 17.5593H10.626C10.6908 17.8287 10.7686 18.0919 10.8587 18.3478H4.14468C2.33976 18.3478 0.869629 16.755 0.869629 14.7994V4.54842C0.869629 2.59285 2.33976 1 4.14468 1ZM15.0615 1.78854H4.14468C2.74004 1.78854 1.59742 3.02654 1.59742 4.54842V6.51976H17.6088V4.54842C17.6088 3.02654 16.4661 1.78854 15.0615 1.78854Z"
                              fill="#fff"
                            />
                            <path
                              d="M18.3365 8.53447L18.1946 9.01391L18.8365 9.2039V8.53447H18.3365ZM17.6088 8.37075H17.1088V8.79893L17.5318 8.8648L17.6088 8.37075ZM17.6088 7.3083H18.1088V6.8083H17.6088V7.3083ZM1.59742 7.3083V6.8083H1.09742V7.3083H1.59742ZM10.626 17.5593L11.1122 17.4424L11.0201 17.0593H10.626V17.5593ZM10.8587 18.3478V18.8478H11.5648L11.3304 18.1818L10.8587 18.3478ZM1.59742 6.51976H1.09742V7.01976H1.59742V6.51976ZM17.6088 6.51976V7.01976H18.1088V6.51976H17.6088ZM15.0615 0.5H4.14468V1.5H15.0615V0.5ZM18.8365 4.54842C18.8365 2.3552 17.1795 0.5 15.0615 0.5V1.5C16.5533 1.5 17.8365 2.83049 17.8365 4.54842H18.8365ZM18.8365 8.53447V4.54842H17.8365V8.53447H18.8365ZM17.5318 8.8648C17.757 8.89986 17.9782 8.94984 18.1946 9.01391L18.4785 8.05503C18.2199 7.9785 17.9553 7.91868 17.6857 7.8767L17.5318 8.8648ZM17.1088 7.3083V8.37075H18.1088V7.3083H17.1088ZM1.59742 7.8083H17.6088V6.8083H1.59742V7.8083ZM2.09742 14.7994V7.3083H1.09742V14.7994H2.09742ZM4.14468 17.0593C3.05317 17.0593 2.09742 16.0836 2.09742 14.7994H1.09742C1.09742 16.5589 2.42692 18.0593 4.14468 18.0593V17.0593ZM10.626 17.0593H4.14468V18.0593H10.626V17.0593ZM11.3304 18.1818C11.246 17.942 11.173 17.6953 11.1122 17.4424L10.1399 17.6761C10.2086 17.9621 10.2913 18.2417 10.3871 18.5138L11.3304 18.1818ZM4.14468 18.8478H10.8587V17.8478H4.14468V18.8478ZM0.369629 14.7994C0.369629 16.9926 2.02663 18.8478 4.14468 18.8478V17.8478C2.65289 17.8478 1.36963 16.5173 1.36963 14.7994H0.369629ZM0.369629 4.54842V14.7994H1.36963V4.54842H0.369629ZM4.14468 0.5C2.02663 0.5 0.369629 2.3552 0.369629 4.54842H1.36963C1.36963 2.83049 2.65289 1.5 4.14468 1.5V0.5ZM4.14468 2.28854H15.0615V1.28854H4.14468V2.28854ZM2.09742 4.54842C2.09742 3.26419 3.05317 2.28854 4.14468 2.28854V1.28854C2.42692 1.28854 1.09742 2.7889 1.09742 4.54842H2.09742ZM2.09742 6.51976V4.54842H1.09742V6.51976H2.09742ZM17.6088 6.01976H1.59742V7.01976H17.6088V6.01976ZM17.1088 4.54842V6.51976H18.1088V4.54842H17.1088ZM15.0615 2.28854C16.153 2.28854 17.1088 3.26419 17.1088 4.54842H18.1088C18.1088 2.7889 16.7793 1.28854 15.0615 1.28854V2.28854Z"
                              fill="#fff"
                            />
                          </svg>
                          </div>
                          <span>{t("customise_payment")}</span>
                        </Link>
                      </li> */}
                    </>
                  {/* )} */}
                  <li>
                    <Link
                      to="/account-settings"
                      onClick={() => dispatch(toggleSidebar())}
                      className={`${
                        location.pathname.includes("account-settings") &&
                        "active"
                      }`}
                    >
                       <div className="collapse-icons">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="21"
                          fill="none"
                          viewBox="0 0 22 21"
                        >
                          <path
                            fill="#000"
                            d="M7.645 20.41a2.94 2.94 0 0 1-1.451-.39l-1.495-.867a2.925 2.925 0 0 1-1.082-3.999.77.77 0 0 0-.672-1.083A2.93 2.93 0 0 1 0 11.145v-1.8A2.95 2.95 0 0 1 2.956 6.41a.757.757 0 0 0 .784-.764.8.8 0 0 0-.102-.385 2.88 2.88 0 0 1-.303-2.232c.2-.753.691-1.396 1.364-1.788L6.194.395a2.93 2.93 0 0 1 3.995 1.084.76.76 0 0 0 .671.39.74.74 0 0 0 .66-.39A2.93 2.93 0 0 1 13.308.101a2.9 2.9 0 0 1 2.22.293l1.484.856c.67.39 1.16 1.029 1.364 1.777a2.9 2.9 0 0 1-.303 2.222.77.77 0 0 0 0 .78.74.74 0 0 0 .66.38 2.933 2.933 0 0 1 2.935 2.936v1.723a2.93 2.93 0 0 1-1.805 2.703 2.9 2.9 0 0 1-1.119.223.78.78 0 0 0-.774.77c0 .133.035.263.103.378a2.927 2.927 0 0 1-1.083 4.01l-1.483.867a2.943 2.943 0 0 1-4.007-1.084.74.74 0 0 0-.66-.38.74.74 0 0 0-.66.38 2.96 2.96 0 0 1-2.534 1.474m-2.166-4.161a.77.77 0 0 0 .292 1.03l1.495.855a.76.76 0 0 0 1.082-.27 2.9 2.9 0 0 1 2.545-1.474 2.87 2.87 0 0 1 2.534 1.463.77.77 0 0 0 1.082.281l1.495-.856a.73.73 0 0 0 .346-.466.75.75 0 0 0-.076-.585 2.937 2.937 0 0 1 2.545-4.4.76.76 0 0 0 .758-.758V9.346a.76.76 0 0 0-.758-.77 2.933 2.933 0 0 1-3-2.915 2.94 2.94 0 0 1 .39-1.484.77.77 0 0 0 .076-.596.74.74 0 0 0-.346-.455l-1.495-.867a.757.757 0 0 0-1.039.281 2.89 2.89 0 0 1-2.545 1.474 2.88 2.88 0 0 1-2.533-1.452.78.78 0 0 0-1.083-.292l-1.494.866a.76.76 0 0 0-.369.445.78.78 0 0 0 .076.585 2.928 2.928 0 0 1-2.523 4.41.78.78 0 0 0-.79.77v1.723a.76.76 0 0 0 .769.758 2.933 2.933 0 0 1 2.934 2.932c.001.515-.133 1.021-.39 1.468z"
                          ></path>
                          <path
                            fill="#000"
                            d="M10.85 13.995a3.79 3.79 0 0 1-3.502-2.342 3.796 3.796 0 0 1 2.762-5.171A3.79 3.79 0 0 1 14 8.095a3.795 3.795 0 0 1-3.15 5.9m0-5.419a1.623 1.623 0 0 0-1.594 1.943 1.626 1.626 0 0 0 2.215 1.185 1.625 1.625 0 0 0-.622-3.128"
                            opacity="0.5"
                          ></path>
                        </svg>
                      </div>
                      <span>{t("account_settings")}</span>
                    </Link>
                  </li>
                </React.Fragment>
              )}
            </ul>
            {/* <ul className="admin-ui-sidebar-list list-unstyled">
              <li>
                <Link to="#">
                  <Image
                    className="logo"
                    src={window.location.origin + "/img/logo.png"}
                  />
                </Link>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CollapseSidebar;
